import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The InfoSmallerCompaniesCompared's component.
 */
const InfoSmallerCompaniesCompared = () => (
  <GridContainer padding="0 0 8px" spacing={2}>
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-SmallerCompaniesCompared.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el indicador de monto transado u órdenes de compra.</Item>
        <Item>Selecciona el sector de estado.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Corresponde al monto o número de órdenes de compra.</Item>
        <Item>Área del monto total transado.</Item>
        <Item>Área del monto transado por Empresas de menor tamaño</Item>
        <Item>Año vigente y años anteriores.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default InfoSmallerCompaniesCompared
